import React, { Component } from "react";
import { connect } from "react-redux";
import LoginController from "./Router";
import { setAdminLogin, fetchToken, onLogout } from "../features/auth/authActions";
import { viewLinkById } from "../features/admin/adminActions";


export class Controller_con extends Component {

  render() {
    return (
      <LoginController {...this.props} />
    );
  }
};

export const mapStateToProps = store => {
  return {
    login: store.login,
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    setAdminLogin: (payload) => {
      dispatch(setAdminLogin(payload));
    },
    fetchToken: (token) => {
      dispatch(fetchToken(token));
    },
    onLogout: (token) => {
      dispatch(onLogout(token));
    },
    viewLinkById: (user_id, token) => {
      dispatch(viewLinkById(user_id, token));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Controller_con);